// Custom JavaScript code
$(document).ready(function() {
    const chatContainer = $('.chat-container');
    
    // Генерація або отримання ідентифікатора сесії
    let sessionId = localStorage.getItem('ai_chat_session_id');
    if (!sessionId) {
        sessionId = 'session_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
        localStorage.setItem('ai_chat_session_id', sessionId);
    }
    
    // Зберігання історії повідомлень (тільки для відображення)
    let conversationHistory = JSON.parse(localStorage.getItem('ai_chat_history') || '[]');
    
    // Відновлення історії розмови при завантаженні
    restoreChatHistory();
    
    // Функція для додавання повідомлення в чат
    function addMessage(text, isUser = true) {
        const messageClass = isUser ? 'user' : 'ai';
        const message = $(`
            <div class="message ${messageClass}">
                <div class="message-label"></div>
                <div class="message-text">${text}</div>
            </div>
        `);
        
        chatContainer.append(message);
        
        // Додаємо повідомлення в історію
        conversationHistory.push({
            role: isUser ? 'user' : 'assistant',
            content: text,
            timestamp: new Date().toISOString()
        });
        
        // Зберігаємо історію в localStorage
        localStorage.setItem('ai_chat_history', JSON.stringify(conversationHistory));
        
        scrollToBottom();
    }
    
    // Функція для показу індикатора завантаження
    function showLoading() {
        const loading = $(`
            <div class="loading">
                <span>AI is thinking</span>
                <div class="loading-dots">
                    <div class="loading-dot"></div>
                    <div class="loading-dot"></div>
                    <div class="loading-dot"></div>
                </div>
            </div>
        `);
        
        chatContainer.append(loading);
        scrollToBottom();
        return loading;
    }
    
    // Функція для прокручування до низу
    function scrollToBottom() {
        const topSection = $('.top-section');
        topSection.scrollTop(topSection[0].scrollHeight);
    }
    
    // Функція для додавання карток колекцій
    function addCollectionCards(collections) {
        if (!collections || collections.length === 0) return;
        
        const collectionsContainer = $(`
            <div class="collections-container">
                <h3>Recommended Collections:</h3>
                <div class="collections-grid"></div>
            </div>
        `);
        
        const grid = collectionsContainer.find('.collections-grid');
        
        collections.forEach(collection => {
            const collectionCard = createCollectionCard(collection);
            grid.append(collectionCard);
        });
        
        chatContainer.append(collectionsContainer);
        
        // Зберігаємо колекції в історії
        conversationHistory.push({
            role: 'collections',
            content: collections,
            timestamp: new Date().toISOString()
        });
        
        scrollToBottom();
    }

    // Функція для додавання карток товарів
    function addProductCards(items) {
        if (!items || items.length === 0) return;
        
        const productsContainer = $(`
            <div class="products-container">
                <h3>Recommended Products:</h3>
                <div class="products-grid"></div>
            </div>
        `);
        
        const grid = productsContainer.find('.products-grid');
        
        items.forEach(item => {
            const productCard = createProductCard(item);
            grid.append(productCard);
        });
        
        chatContainer.append(productsContainer);
        
        // Зберігаємо товари в історії
        conversationHistory.push({
            role: 'products',
            content: items,
            timestamp: new Date().toISOString()
        });
        
        // Зберігаємо історію в localStorage
        localStorage.setItem('ai_chat_history', JSON.stringify(conversationHistory));
        
        scrollToBottom();
    }
    
    // Функція для створення картки товару
    function createProductCard(item) {
        // Знаходимо найдешевший варіант
        const minPrice = Math.min(...item.variants.map(v => v.price));
        const maxPrice = Math.max(...item.variants.map(v => v.price));
        const priceText = minPrice === maxPrice ? `$${minPrice} CAD` : `$${minPrice} - $${maxPrice} CAD`;
        
        // Отримуємо перше зображення
        const imageUrl = item.image ? item.image.src : (item.images.length > 0 ? item.images[0].src : '');
        
        // Варіанти тепер не відображаємо
        const optionsHtml = '';
        
        return $(`
            <div class="product-card" data-product-id="${item.id}">
                <div class="product-image">
                    <img src="${imageUrl}" alt="${item.title}" onerror="this.style.display='none'">
                </div>
                <div class="product-info">
                    <h3 class="product-title">${item.title}</h3>
                    <p class="product-type">${item.productType}</p>
                    <div class="product-price">${priceText}</div>
                    ${optionsHtml}
                    <button class="add-to-cart-btn" onclick="window.open('https://luxurydiamonds.ca/products/${item.handle}', '_blank')">
                        View Product
                    </button>
                </div>
            </div>
        `);
    }

    // Функція для створення картки колекції
    function createCollectionCard(collection) {
        const imageUrl = collection.imageSrc || '';
        
        // Якщо є collection.url — використовуємо його, інакше будуємо стандартний URL
        const url = collection.url || (collection.handle ? `https://luxurydiamonds.ca/collections/${collection.handle}` : '#');
        return $(
            `<div class="collection-card" data-collection-id="${collection.id}">
                <div class="collection-image">
                    <img src="${imageUrl}" alt="${collection.title}" onerror="this.style.display='none'">
                </div>
                <div class="collection-info">
                    <h3 class="collection-title">${collection.title}</h3>
                    <button class="view-collection-btn" onclick="window.open('${url}', '_blank')">
                        View Collection
                    </button>
                </div>
            </div>`
        );
    }
    
    // Додає або оновлює блок швидких питань
    function updateQuickQuestions(questions) {
        const quickQuestionsDiv = $('.quick-questions');
        quickQuestionsDiv.empty();
        if (Array.isArray(questions) && questions.length > 0) {
            questions.forEach(q => {
                quickQuestionsDiv.append(`<button class="quick-question-btn">${q}</button>`);
            });
        }
        // Зберігаємо в історію
        conversationHistory.push({
            role: 'quickQuestions',
            content: questions,
            timestamp: new Date().toISOString()
        });
        localStorage.setItem('ai_chat_history', JSON.stringify(conversationHistory));
    }

    // Функція для відновлення історії чату
    function restoreChatHistory() {
        conversationHistory.forEach(msg => {
            if (msg.role === 'user') {
                const message = $(`
                    <div class="message user">
                        <div class="message-label"></div>
                        <div class="message-text">${msg.content}</div>
                    </div>
                `);
                chatContainer.append(message);
            } else if (msg.role === 'assistant') {
                const message = $(`
                    <div class="message ai">
                        <div class="message-label"></div>
                        <div class="message-text">${msg.content}</div>
                    </div>
                `);
                chatContainer.append(message);
            } else if (msg.role === 'collections' && Array.isArray(msg.content)) {
                // Відновлюємо картки колекцій
                const collectionsContainer = $(`
                    <div class="collections-container">
                        <h3>Recommended Collections:</h3>
                        <div class="collections-grid"></div>
                    </div>
                `);
                
                const grid = collectionsContainer.find('.collections-grid');
                
                msg.content.forEach(collection => {
                    const collectionCard = createCollectionCard(collection);
                    grid.append(collectionCard);
                });
                
                chatContainer.append(collectionsContainer);
            } else if (msg.role === 'products' && Array.isArray(msg.content)) {
                // Відновлюємо картки товарів
                const productsContainer = $(`
                    <div class="products-container">
                        <h3>Recommended Products:</h3>
                        <div class="products-grid"></div>
                    </div>
                `);
                
                const grid = productsContainer.find('.products-grid');
                
                msg.content.forEach(item => {
                    const productCard = createProductCard(item);
                    grid.append(productCard);
                });
                
                chatContainer.append(productsContainer);
            } else if (msg.role === 'quickQuestions' && Array.isArray(msg.content)) {
                updateQuickQuestions(msg.content);
            }
        });
        
        if (conversationHistory.length > 0) {
            scrollToBottom();
        }
    }
    
    // Функція для очищення історії чату
    async function clearChatHistory() {
        try {
            // Відправляємо запит на сервер для очищення сесії
            const response = await fetch('https://luxurydiamondsapp.org/api/ai/clear-session', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ sessionId: sessionId })
            });
            
            if (response.ok) {
                // Очищаємо локальні дані тільки після успішного очищення на сервері
                conversationHistory = [];
                localStorage.removeItem('ai_chat_history');
                localStorage.removeItem('ai_chat_session_id');
                chatContainer.empty();
                
                // Генеруємо новий session ID
                sessionId = 'session_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
                localStorage.setItem('ai_chat_session_id', sessionId);
            } else {
                console.error('Error clearing session on server');
            }
        } catch (error) {
            console.error('Error clearing session:', error);
            // In case of error, still clear local data
            conversationHistory = [];
            localStorage.removeItem('ai_chat_history');
            localStorage.removeItem('ai_chat_session_id');
            chatContainer.empty();
            
            sessionId = 'session_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
            localStorage.setItem('ai_chat_session_id', sessionId);
        }
    }
    
    // Функція для відправки повідомлення на API
    async function sendMessage(message) {
        const loadingElement = showLoading();
        
        try {
            // Повертаємось до FormData, оскільки сервер очікує саме цей формат
            const formData = new FormData();
            formData.append('message', message);
            formData.append('sessionId', sessionId);
            
            console.log('Sending message:', message);
            console.log('Session ID:', sessionId);
            
            const response = await fetch('https://luxurydiamondsapp.org/api/ai', {
                method: 'POST',
                body: formData
            });
            
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            
            const result = await response.json();
            
            console.log('Server response:', result);
            
            // Видаляємо індикатор завантаження
            loadingElement.remove();
            
            // Оновлюємо sessionId якщо сервер повернув новий
            if (result.sessionId && result.sessionId !== sessionId) {
                sessionId = result.sessionId;
                localStorage.setItem('ai_chat_session_id', sessionId);
            }
            
            // Додаємо відповідь AI (витягуємо текст з поля answer)
            if (result.answer) {
                addMessage(result.answer, false);
            } else {
                addMessage('Received response without text', false);
            }
            
            let collectionsCards = [];

            // Якщо є labDiamondsPage, додаємо окрему картку-колекцію
            if (result.labDiamondsPage) {
                const labDiamondsCollection = {
                    id: 'lab-diamonds-page',
                    title: 'Lab Grown Diamonds',
                    handle: '',
                    imageSrc: 'https://luxurydiamonds.ca/cdn/shop/t/19/assets/round.jpg',
                    url: result.labDiamondsPage
                };
                collectionsCards.push(labDiamondsCollection);
            }

            // Додаємо колекції, якщо вони є
            if (result.collections && result.collections.length > 0) {
                collectionsCards = collectionsCards.concat(result.collections);
            }

            addCollectionCards(collectionsCards);
            
            // Потім додаємо товари, якщо вони є
            if (result.items && result.items.length > 0) {
                addProductCards(result.items);
            }
            
            // Оновлюємо quickQuestions, якщо вони є
            if (result.quickQuestions && Array.isArray(result.quickQuestions)) {
                updateQuickQuestions(result.quickQuestions);
            }
            
        } catch (error) {
            console.error('Error sending message:', error);
            
            // Remove loading indicator
            loadingElement.remove();
            
            // Show error message
            addMessage('Sorry, an error occurred while processing your request. Please try again.', false);
        }
    }
    

    // Handler for Send button
    $('#sendBtn').click(async function() {
        const inputText = $('#textInput').val().trim();
        if (inputText !== '') {
            await sendUserMessage(inputText);
        }
    });

    // Handler for quick question buttons
    $(document).on('click', '.quick-question-btn', async function() {
        const question = $(this).text();
        await sendUserMessage(question);
    });

    // Unified function to send user message (from input or quick question)
    async function sendUserMessage(text) {
        addMessage(text, true);
        $('#textInput').val('');
        $('#sendBtn').prop('disabled', true);
        $('#textInput').prop('disabled', true);
        await sendMessage(text);
        $('#sendBtn').prop('disabled', false);
        $('#textInput').prop('disabled', false);
        $('#textInput').focus();
    }
    
    // Handler for Enter key in input field
    $('#textInput').keypress(function(e) {
        if (e.which === 13 && !$('#sendBtn').prop('disabled')) { // Enter
            $('#sendBtn').click();
        }
    });
    
    // Handler for clear history button
    $('#clearBtn').click(async function() {
        if (confirm('Are you sure you want to clear all chat history?')) {
            await clearChatHistory();
        }
    });
    
    // Якщо є ai_form_input у localStorage — відправляємо як повідомлення і видаляємо
    const aiFormInput = localStorage.getItem('ai_form_input');
    if (aiFormInput && aiFormInput.trim() !== '') {
        addMessage(aiFormInput, true);
        sendMessage(aiFormInput);
        localStorage.removeItem('ai_form_input');
    }
});